var map = {
	"./elem1-ability2.gif": "89b7",
	"./elem2-ability2.gif": "b497",
	"./elem3-ability2.gif": "bbfb",
	"./elem4-ability2.gif": "16e7",
	"./elem5-ability2.gif": "964a",
	"./elem6-ability2.gif": "d78d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9896";